import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './AlternateItemsEntity.g';

function getProductsSalesAgreementQuery(): DataServiceQuery {
    return new DataServiceQuery();
    }


export function getProductsSalesAgreementInput (
  productRecIds:
      number[]
): IDataServiceRequest {
const query = getProductsSalesAgreementQuery();
return query.createDataServiceRequestForOperation(
    'GetProductsSalesAgreement',
    true,
      DataServiceEntities.GCGetCustomTradeAgreementResponseExtensionClass
    ,
    'false',
    { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGCGetCustomTradeAgreementResponse' },
    {
    ProductRecIds: productRecIds
    }
);
}

export function getProductsSalesAgreementAsync (
  context: IContext, productRecIds:
      number[]
  ): AsyncResult<DataServiceEntities.IGCGetCustomTradeAgreementResponse> {
  const request = getProductsSalesAgreementInput(productRecIds);
  return callActionOrExecute<DataServiceEntities.IGCGetCustomTradeAgreementResponse>(request, context.callerContext);
  }